import { isEmpty } from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import * as actions from '../../actions'
import { ADD_ERROR } from '../../actions/types'
import RenderDateField from '../booking/renderDateField'
import RenderField from '../booking/renderField'
import RenderStatusField from '../booking/renderStatusField'
import validate from '../util/validate'
import Spinner from '../util/spinner'
import RenderBuyTerms from './renderBuyTerms'
import RenderReactSelect from '../booking/RenderReactSelect'

class BookingAirNew extends Component {
  constructor(props) {
    super(props)
    this.onBookingSubmit = this.onBookingSubmit.bind(this)
  }

  componentDidMount() {
    // check if accessLevel is agent, else
    // show error, access is denied.
    const { accessLevel } = this.props.user
    if (accessLevel !== 'AGENT') {
      this.props.history.push('/p/search')
      this.props.dispatch(this.addError('ACCESS DENIED'))
    } else {
      this.props.fetchPorts()
    }
  }

  addError(error) {
    return {
      type: ADD_ERROR,
      payload: error,
    }
  }

  onBookingSubmit(values) {
    const { customer, user, ShipmentType, CNeeID, station } = this.props
    values.PrepareBy = user.username
    values.Agent = user.id
    values.ShipmentType = ShipmentType
    values.CNeeID = CNeeID
    values.station = station
    customer.forEach(item => {
      if (item.customerNo.toString() === values.CNeeID) {
        values.CNeeName = item.companyName
      }
    })
    // console.log(values);
    this.props.createBookingHeader(values, () => {
      // const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
      // sleep(1000).then(() => this.props.history.push(`/booking/${this.props.newBookingID.BookingID}`));
      this.props.history.push(`/p/booking/${this.props.newBookingID.BookingID}`)
    })
  }

  render() {
    const { handleSubmit, ports } = this.props
    if (isEmpty(ports)) {
      return <Spinner />
    }
    return (
      <form onSubmit={handleSubmit(this.onBookingSubmit)}>
        {/* <div className="row">
          <Field label="Consignee Name:" name="CNeeID" component={RenderConsignee} />
        </div> */}
        <div className="row">
          <Field label="Flight No:" name="FlightNo" component={RenderField} />
          <Field
            label="Booking Status:"
            name="bkStatus"
            component={RenderStatusField}
          />
        </div>
        <div className="row">
          <Field
            label="Connecting Flight No:"
            type="text"
            name="ConnectingFlightNo"
            component={RenderField}
          />
        </div>
        <div className="row">
          <Field
            label="Shpmt. buying terms:"
            type="text"
            name="buyTerm"
            component={RenderBuyTerms}
          />
          <Field
            label="Master AWB:"
            type="text"
            name="mawb"
            component={RenderField}
          />
        </div>
        <div className="row">
          <Field
            label="Original Port:"
            type="text"
            name="OrgPort"
            data={ports.orgPorts}
            component={RenderReactSelect}
          />
          <Field
            label="ETD:"
            type="text"
            name="ETD"
            component={RenderDateField}
          />
        </div>
        <div className="row">
          <Field
            label="Transit Port:"
            type="text"
            name="DstPort"
            data={ports.dstPorts}
            component={RenderReactSelect}
          />
          <Field
            label="(Transit Port) ETA:"
            type="text"
            name="ETAFirst"
            component={RenderDateField}
          />
        </div>
        <div className="row">
          <Field
            label="Final Destination:"
            type="text"
            name="FnlPort"
            data={ports.fnlPorts}
            component={RenderReactSelect}
          />
          <Field
            label="(Final port) ETA:"
            type="text"
            name="ETAFinal"
            component={RenderDateField}
          />
        </div>
        <div className="row text-center">
          <button
            type="submit"
            name="submitBooking"
            className="btn btn-default"
          >
            Create
          </button>
        </div>
        <hr />
      </form>
    )
  }
}

function mapStateToProps({ util, bookings, auth, ports }) {
  return {
    customer: util.customer,
    user: auth.user,
    newBookingID: bookings.newBookingID,
    ports,
  }
}

BookingAirNew = reduxForm({
  form: 'BookingAirNew',
  enableReinitialize: true,
  validate,
})(BookingAirNew)

BookingAirNew = withRouter(connect(mapStateToProps, actions)(BookingAirNew))
export default BookingAirNew
